import { useLanguage } from "../i18n/LanguageContext";
import { TitleLines } from "../i18n/text";
import "./RealDeviceSection.css";

export function RealDeviceSection() {
    const { t } = useLanguage();

    return (
        <section className="section realDeviceSection" id="device">
            <div className="sectionText realDeviceText">
                <p className="eyebrow">{t.device.eyebrow}</p>

                <h2>
                    <TitleLines lines={t.device.titleLines} />
                </h2>

                <p className="lead">{t.device.lead}</p>
            </div>

            <div className="restaurantGallery">
                <figure className="restaurantPhoto restaurantPhotoWide">
                    <img
                        src="/pictures/images/restaurant-table.jpeg"
                        alt={t.device.restaurantAlt}
                        width={1280}
                        height={960}
                        loading="lazy"
                        decoding="async"
                    />
                    <figcaption>{t.device.restaurantCaption}</figcaption>
                </figure>
                <figure className="restaurantPhoto restaurantPhotoMenu">
                    <img
                        src="/pictures/images/restaurant-menu.jpeg"
                        alt={t.device.menuAlt}
                        width={960}
                        height={1280}
                        loading="lazy"
                        decoding="async"
                    />
                    <figcaption>{t.device.menuCaption}</figcaption>
                </figure>
                <figure className="restaurantPhoto">
                    <img
                        src="/pictures/images/restaurant-games.jpeg"
                        alt={t.device.gamesAlt}
                        width={960}
                        height={1280}
                        loading="lazy"
                        decoding="async"
                    />
                    <figcaption>{t.device.gamesCaption}</figcaption>
                </figure>
            </div>
        </section>
    );
}
